// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

.col-md-4 {
  margin-left: auto;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/previous-analysis/show-table/show-table.component.scss","webpack://./../../audit%20module/RedThread/src/app/pages/previous-analysis/show-table/show-table.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;ACCF;;ADEA;EACE,iBAAA;EACA,mBAAA;ACCF","sourcesContent":["table {\r\n  width: 100%;\r\n}\r\n\r\n.col-md-4 {\r\n  margin-left: auto;\r\n  margin-bottom: 10px;\r\n}","table {\n  width: 100%;\n}\n\n.col-md-4 {\n  margin-left: auto;\n  margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
